(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      
      // Watch for mobile menu open/close
      this.watchMobileMenu();
    }

    watchMobileMenu() {
      // Watch for header drawer (mobile menu) opening - using details element inside header-drawer
      const headerDrawer = document.querySelector('header-drawer');
      if (headerDrawer) {
        const detailsElement = headerDrawer.querySelector('details');
        if (detailsElement) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.attributeName === 'open') {
                if (detailsElement.hasAttribute('open')) {
                  this.headerWrapper.classList.add('menu-open');
                } else {
                  this.headerWrapper.classList.remove('menu-open');
                }
              }
            });
          });
          
          observer.observe(detailsElement, {
            attributes: true,
            attributeFilter: ['open']
          });
        }
      }
      
      // Also watch for details modal (search, etc)
      const detailsModals = document.querySelectorAll('details-modal');
      detailsModals.forEach(modal => {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'open') {
              if (modal.hasAttribute('open')) {
                this.headerWrapper.classList.add('menu-open');
              } else {
                this.headerWrapper.classList.remove('menu-open');
              }
            }
          });
        });
        
        observer.observe(modal, {
          attributes: true,
          attributeFilter: ['open']
        });
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Handle transparent header scroll color change
      if (this.headerWrapper && this.headerWrapper.classList.contains('header-wrapper--transparent')) {
        if (scrollTop > 100) {
          this.headerWrapper.classList.add('scrolled-past-header');
        } else {
          this.headerWrapper.classList.remove('scrolled-past-header');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Custom Cart Icon Preservation
  class CustomCartIcon {
    constructor() {
      this.cartIcon = document.getElementById('cart-icon-bubble');
      if (!this.cartIcon) return;
      
      this.displayType = this.cartIcon.dataset.cartDisplayType;
      this.cartText = this.cartIcon.dataset.cartText || 'CART';
      this.cartIconImage = this.cartIcon.dataset.cartIconImage;
      
      this.init();
    }

    init() {
      // Listen for cart updates
      document.addEventListener('cart:refresh', () => this.updateCartDisplay());
      
      // Observe DOM changes to the cart icon
      if (this.displayType === 'text' || this.displayType === 'custom_image') {
        this.observeCartChanges();
      }
    }

    observeCartChanges() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            // Check if our custom display was replaced
            if (this.displayType === 'text' && !this.cartIcon.querySelector('.cart-text-wrapper')) {
              this.restoreTextDisplay();
            } else if (this.displayType === 'custom_image' && !this.cartIcon.querySelector('.cart-icon-wrapper')) {
              this.restoreImageDisplay();
            }
          }
        });
      });

      observer.observe(this.cartIcon, {
        childList: true,
        subtree: true
      });
    }

    restoreTextDisplay() {
      // Get current cart count
      const cartCount = this.getCartCount();
      
      // Clear and rebuild
      const visuallyHidden = this.cartIcon.querySelector('.visually-hidden');
      this.cartIcon.innerHTML = '';
      
      const textWrapper = document.createElement('span');
      textWrapper.className = 'cart-text-wrapper';
      textWrapper.textContent = this.cartText;
      
      if (cartCount > 0) {
        const countBubble = document.createElement('span');
        countBubble.className = 'cart-count-bubble';
        const countSpan = document.createElement('span');
        countSpan.setAttribute('aria-hidden', 'true');
        countSpan.textContent = cartCount;
        countBubble.appendChild(countSpan);
        textWrapper.appendChild(countBubble);
      }
      
      this.cartIcon.appendChild(textWrapper);
      if (visuallyHidden) this.cartIcon.appendChild(visuallyHidden);
    }

    restoreImageDisplay() {
      const cartCount = this.getCartCount();
      const visuallyHidden = this.cartIcon.querySelector('.visually-hidden');
      
      this.cartIcon.innerHTML = '';
      
      if (this.cartIconImage) {
        const iconWrapper = document.createElement('span');
        iconWrapper.className = 'cart-icon-wrapper';
        const img = document.createElement('img');
        img.src = this.cartIconImage;
        img.alt = 'Cart';
        img.loading = 'lazy';
        iconWrapper.appendChild(img);
        this.cartIcon.appendChild(iconWrapper);
      }
      
      if (cartCount > 0) {
        const countBubble = document.createElement('div');
        countBubble.className = 'cart-count-bubble';
        const countSpan = document.createElement('span');
        countSpan.setAttribute('aria-hidden', 'true');
        countSpan.textContent = cartCount;
        countBubble.appendChild(countSpan);
        
        const hiddenCount = document.createElement('span');
        hiddenCount.className = 'visually-hidden';
        hiddenCount.textContent = `${cartCount} items in cart`;
        countBubble.appendChild(hiddenCount);
        
        this.cartIcon.appendChild(countBubble);
      }
      
      if (visuallyHidden) this.cartIcon.appendChild(visuallyHidden);
    }

    getCartCount() {
      const countElement = this.cartIcon.querySelector('.cart-count-bubble [aria-hidden="true"]');
      return countElement ? parseInt(countElement.textContent) || 0 : 0;
    }

    updateCartDisplay() {
      if (this.displayType === 'text') {
        this.restoreTextDisplay();
      } else if (this.displayType === 'custom_image') {
        this.restoreImageDisplay();
      }
    }
  }

  // Initialize custom cart icon handler
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new CustomCartIcon());
  } else {
    new CustomCartIcon();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
  // Transparent Password Header Scroll Handler
  class TransparentPasswordHeader {
    constructor() {
      this.headerWrapper = document.querySelector('.password-header-wrapper--transparent');
      if (!this.headerWrapper) return;
      
      this.init();
    }

    init() {
      window.addEventListener('scroll', this.onScroll.bind(this), false);
      // Check initial scroll position
      this.onScroll();
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > 100) {
        this.headerWrapper.classList.add('scrolled-past-header');
      } else {
        this.headerWrapper.classList.remove('scrolled-past-header');
      }
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new TransparentPasswordHeader());
  } else {
    new TransparentPasswordHeader();
  }

  } catch(e) { console.error(e); }
})();
})();
